// extracted by mini-css-extract-plugin
export default {"content":"Greeting_content__IpY1V","greeting":"Greeting_greeting__1HIDT","products":"Greeting_products__rcAZP","product":"Greeting_product__aBCER"};